<div class="modal-header">
    <h4 class="modal-title fw-bold">
        <span *ngIf="model.userUUID" jhiTranslate="site-admin.user.modal.edit.header"></span>
        <span *ngIf="!model.userUUID" jhiTranslate="site-admin.user.modal.create.header"></span>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <div class="container">
        <form name="form" #f="ngForm">
            <div class="mb-3 row">
                <div class="col-sm-12">
                    <span class="mandatory-asterisk"></span><span jhiTranslate="site-admin.user.modal.mandatory.fields"></span>
                </div>
            </div>
            <div class="mb-3 row required">
                <label for="firstName" class="col-sm-3 col-form-label fw-bold" jhiTranslate="site-admin.user.modal.first.name"></label>
                <div class="col-sm-4">
					<input type="text" class="form-control" [(ngModel)]="model.firstName" #firstName="ngModel" jhi-forbiddenCharactersValidator required name="firstName" id="firstName" placeholder="{{ 'site-admin.user.columns.first-name' | translate }}" maxlength="20">
                </div>
                <div class="col-sm-1"></div>
                <div class="col-sm-4">
					<input type="text" class="form-control" [(ngModel)]="model.lastName" #lastName="ngModel" jhi-forbiddenCharactersValidator required name="lastName" id="lastName" placeholder="{{ 'site-admin.user.columns.last-name' | translate }}" maxlength="50">
                </div>

            </div>
            <div class="mb-3 row required">
                <label for="userName" class="col-sm-3 col-form-label fw-bold"><span jhiTranslate="site-admin.user.modal.username"></span></label>
                <div class="col-sm-9">
                    <input type="text" class="form-control" [(ngModel)]="model.username" #username="ngModel" jhi-forbiddenCharactersValidator required name="username" id="username"
                           [pattern]="EMAIL_LOCAL_PART_REGEX"
                           title="{{ 'site-admin.user.modal.username.title' | translate }}"
						   placeholder="{{ 'site-admin.user.columns.user-name' | translate }}" maxlength="30">
                </div>
            </div>
            <div class="mb-3 row required">
                <label for="email" class="col-sm-3 col-form-label fw-bold"><span jhiTranslate="site-admin.user.modal.email"></span></label>
                <div class="col-sm-9">
					<input type="text" class="form-control" [(ngModel)]="model.email" #email="ngModel" jhiValidateEmail required name="email" id="email" placeholder="{{ 'site-admin.user.columns.email' | translate }}" maxlength="255">
                </div>
            </div>
            <div class="mb-3 row required">
                <label for="userCrops" class="col-sm-3 col-form-label fw-bold"><span jhiTranslate="site-admin.user.modal.crops"></span></label>
                <div class="col-sm-9">
                    <ng-select required id="userCrops" name="userCrops"  width="100%"
                               bindLabel="cropName"
                               bindValue="cropName"
                               [items]="crops"
                               [multiple]="true"
                               [(ngModel)]="cropSelected"
                               (ngModelChange)="onChangeCrop($event)" #cropsDropdown></ng-select>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-sm-3"></div>
                <div class="col-sm-9">
                    <div class="form-check form-check-inline">
                        <input type="checkbox" class="form-check-input" id="selectAllCrops" [checked]="model.crops.length === crops.length" (click)="onSelectAllCrops($event)"/>
                        <label class="form-check-label" for="selectAllCrops" jhiTranslate="site-admin.user.modal.crops.select.all"></label>
                    </div>
                </div>
            </div>
            <div class="mb-3 row">
                <label for="userRoles" class="col-sm-3 col-form-label fw-bold"><span jhiTranslate="site-admin.user.modal.roles"></span></label>
                <div class="col-sm-9" style="padding-right: 0px;padding-left: 0px;">
                    <div>
                        <a href="javascript:void(0)" (click)="AssignRole()"><span jhiTranslate="site-admin.user.modal.assign.role.link"></span></a>
                    </div>
                    <div *ngIf="model.userRoles?.length > 0" style="overflow-x: auto">
                        <table id="userRoles" class="table table-striped table-curved">
                            <thead>
                            <tr>
                            <th><span jhiTranslate="site-admin.user.modal.columns.role.name"></span></th>
                            <th><span jhiTranslate="site-admin.user.modal.columns.role.type"></span></th>
                            <th><span jhiTranslate="site-admin.user.modal.columns.crop"></span></th>
                            <th><span jhiTranslate="site-admin.user.modal.columns.program"></span></th>
                            <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let userRole of model.userRoles">
                                <td>{{userRole.role.name}}</td>
                                <td>{{userRole.role.roleType.name}}</td>
                                <td>{{userRole.crop?.cropName}}</td>
                                <td>{{userRole.program?.name}}</td>
                                <td><a href="javascript:void(0)" (click)="showDeleteUserRoleConfirmPopUp(userRole)"><i class="fa fa-times" style="color:red"></i></a></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="mb-3 row">
                <label for="status" class="col-sm-3 col-form-label fw-bold" jhiTranslate="site-admin.user.modal.status"></label>
                <div class="col-sm-9" style="padding-left: 0px;">
                    <div class="form-check form-check-inline">
                        <label class="form-check-label">
                            <input class="form-check-input" type="radio" name="options-status" [(ngModel)]="model.active" id="statuson" [value]="true" checked>
                            <span class="ms-1" jhiTranslate="site-admin.active">Active</span>
                        </label>
                    </div>
                    <div class="form-check form-check-inline">
                        <label class="form-check-label">
                            <input class="form-check-input" type="radio" name="options-satus" [(ngModel)]="model.active" id="statusoff" [value]="false">
                            <span class="ms-1" jhiTranslate="site-admin.inactive">Inactive</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="mb-3 row">
                <div class="col-sm-3">
                </div>
                <div class="col-sm-9" style="padding-left: 0px;">
                    <div *ngIf="isEditing" class="form-check form-check-inline">
                        <input type="checkbox" class="form-check-input" [(ngModel)]="sendMail" name="sendMail" id="sendMail"> <label class="form-check-label" for="sendMail" jhiTranslate="site-admin.user.modal.send.email.reset.password"></label>
                    </div>
                </div>
            </div>
            <div class="mb-3 row" *ngIf="context.enableTwoFactorAuthentication">
                <div class="col-sm-3">
                </div>
                <div class="col-sm-9"  style="padding-left: 0px;">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" class="form-check-input" [(ngModel)]="model.multiFactorAuthenticationEnabled" name="multiFactorAuthenticationEnabled">
                            <span class="ms-1" jhiTranslate="site-admin.enable.multi-factor.auth"></span>
                        </label>
                    </div>
                </div>
            </div>
        </form>
        <div *ngIf="sendingEmail">
            <span class="throbber throbber-lg"></span>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="cancel"></span>
    </button>
    <button type="submit" *ngIf="!userSaved"  class="btn btn-primary" [disabled]="!isFormValid(f)">
        <span class="fa fa-save"></span>&nbsp;
        <span (click)="addUser(f)" *ngIf="!model.userUUID" jhiTranslate="site-admin.user.modal.create.user"></span>
        <span (click)="updateUser(f)" *ngIf="model.userUUID" jhiTranslate="site-admin.user.modal.edit.user"></span>
    </button>
    <button *ngIf="userSaved" type="submit" class="btn btn-success" [disabled]="!isFormValid(f)" jhiTranslate="site-admin.user.modal.saved"></button>
</div>
